/* Countries list */

// import Helpers from '../helpers/shared.helper';

// let en_list = [{"CountryCode":"+93","CountryName":"Afghanistan","ISO_2Code":"AF","ISO_3Code":"AFG"},{"CountryCode":"+376","CountryName":"Andorra","ISO_2Code":"AD","ISO_3Code":"AND"},{"CountryCode":"+61","CountryName":"Australia","ISO_2Code":"AU","ISO_3Code":"AUS"},{"CountryCode":"+43","CountryName":"Austria","ISO_2Code":"AT","ISO_3Code":"AUT"},{"CountryCode":"+1","CountryName":"Bahamas","ISO_2Code":"BS","ISO_3Code":"BHS"},{"CountryCode":"+973","CountryName":"Bahrain","ISO_2Code":"BH","ISO_3Code":"BHR"},{"CountryCode":"+880","CountryName":"Bangladesh","ISO_2Code":"BD","ISO_3Code":"BGD"},{"CountryCode":"+32","CountryName":"Belgium","ISO_2Code":"BE","ISO_3Code":"BEL"},{"CountryCode":"+1","CountryName":"Bermuda","ISO_2Code":"BM","ISO_3Code":"BMU"},{"CountryCode":"+975","CountryName":"Bhutan","ISO_2Code":"BT","ISO_3Code":"BTN"},{"CountryCode":"+55","CountryName":"Brazil","ISO_2Code":"BR","ISO_3Code":"BRA"},{"CountryCode":"+673","CountryName":"Brunei Darussalam","ISO_2Code":"BN","ISO_3Code":"BRN"},{"CountryCode":"+855","CountryName":"Cambodia","ISO_2Code":"KH","ISO_3Code":"KHM"},{"CountryCode":"+1","CountryName":"Canada","ISO_2Code":"CA","ISO_3Code":"CAN"},{"CountryCode":"+86","CountryName":"China","ISO_2Code":"CN","ISO_3Code":"CHN"},{"CountryCode":"+57","CountryName":"Colombia","ISO_2Code":"CO","ISO_3Code":"COL"},{"CountryCode":"+506","CountryName":"Costa Rica","ISO_2Code":"CR","ISO_3Code":"CRI"},{"CountryCode":"+357","CountryName":"Cyprus","ISO_2Code":"CY","ISO_3Code":"CYP"},{"CountryCode":"+420","CountryName":"Czech Republic","ISO_2Code":"CZ","ISO_3Code":"CZE"},{"CountryCode":"+45","CountryName":"Denmark","ISO_2Code":"DK","ISO_3Code":"DNK"},{"CountryCode":"+1","CountryName":"Dominican Republic","ISO_2Code":"DO","ISO_3Code":"DOM"},{"CountryCode":"+20","CountryName":"Egypt","ISO_2Code":"EG","ISO_3Code":"EGY"},{"CountryCode":"+503","CountryName":"El Salvador","ISO_2Code":"SV","ISO_3Code":"SLV"},{"CountryCode":"+298","CountryName":"Faroe Islands","ISO_2Code":"FO","ISO_3Code":"FRO"},{"CountryCode":"+358","CountryName":"Finland","ISO_2Code":"FI","ISO_3Code":"FIN"},{"CountryCode":"+33","CountryName":"France","ISO_2Code":"FR","ISO_3Code":"FRA"},{"CountryCode":"+594","CountryName":"French Guiana","ISO_2Code":"GF","ISO_3Code":"GUF"},{"CountryCode":"+49","CountryName":"Germany","ISO_2Code":"DE","ISO_3Code":"DEU"},{"CountryCode":"+350","CountryName":"Gibraltar","ISO_2Code":"GI","ISO_3Code":"GIB"},{"CountryCode":"+30","CountryName":"Greece","ISO_2Code":"GR","ISO_3Code":"GRC"},{"CountryCode":"+590","CountryName":"Guadeloupe","ISO_2Code":"GP","ISO_3Code":"GLP"},{"CountryCode":"+1","CountryName":"Guam","ISO_2Code":"GU","ISO_3Code":"GUM"},{"CountryCode":"+502","CountryName":"Guatemala","ISO_2Code":"GT","ISO_3Code":"GTM"},{"CountryCode":"+592","CountryName":"Guyana","ISO_2Code":"GY","ISO_3Code":"GUY"},{"CountryCode":"+852","CountryName":"Hong Kong","ISO_2Code":"HK","ISO_3Code":"HKG"},{"CountryCode":"+36","CountryName":"Hungary","ISO_2Code":"HU","ISO_3Code":"HUN"},{"CountryCode":"+354","CountryName":"Iceland","ISO_2Code":"IS","ISO_3Code":"ISL"},{"CountryCode":"+91","CountryName":"India","ISO_2Code":"IN","ISO_3Code":"IND"},{"CountryCode":"+62","CountryName":"Indonesia","ISO_2Code":"ID","ISO_3Code":"IDN"},{"CountryCode":"+98","CountryName":"Iran","ISO_2Code":"IR","ISO_3Code":"IRN"},{"CountryCode":"+353","CountryName":"Ireland","ISO_2Code":"IE","ISO_3Code":"IRL"},{"CountryCode":"+39","CountryName":"Italy","ISO_2Code":"IT","ISO_3Code":"ITA"},{"CountryCode":"+81","CountryName":"Japan","ISO_2Code":"JP","ISO_3Code":"JPN"},{"CountryCode":"+962","CountryName":"Jordan","ISO_2Code":"JO","ISO_3Code":"JOR"},{"CountryCode":"+254","CountryName":"Kenya","ISO_2Code":"KE","ISO_3Code":"KEN"},{"CountryCode":"+965","CountryName":"Kuwait","ISO_2Code":"KW","ISO_3Code":"KWT"},{"CountryCode":"+856","CountryName":"Lao People's Democratic Republic","ISO_2Code":"LA","ISO_3Code":"LAO"},{"CountryCode":"+961","CountryName":"Lebanon","ISO_2Code":"LB","ISO_3Code":"LBN"},{"CountryCode":"+352","CountryName":"Luxembourg","ISO_2Code":"LU","ISO_3Code":"LUX"},{"CountryCode":"+853","CountryName":"Macao","ISO_2Code":"MO","ISO_3Code":"MAC"},{"CountryCode":"+60","CountryName":"Malaysia","ISO_2Code":"MY","ISO_3Code":"MYS"},{"CountryCode":"+356","CountryName":"Malta","ISO_2Code":"MT","ISO_3Code":"MLT"},{"CountryCode":"+692","CountryName":"Marshall Islands","ISO_2Code":"MH","ISO_3Code":"MHL"},{"CountryCode":"+596","CountryName":"Martinique","ISO_2Code":"MQ","ISO_3Code":"MTQ"},{"CountryCode":"+230","CountryName":"Mauritius","ISO_2Code":"MU","ISO_3Code":"MUS"},{"CountryCode":"+262","CountryName":"Mayotte","ISO_2Code":"YT","ISO_3Code":"MYT"},{"CountryCode":"+52","CountryName":"Mexico","ISO_2Code":"MX","ISO_3Code":"MEX"},{"CountryCode":"+976","CountryName":"Mongolia","ISO_2Code":"MN","ISO_3Code":"MNG"},{"CountryCode":"+264","CountryName":"Namibia","ISO_2Code":"NA","ISO_3Code":"NAM"},{"CountryCode":"+977","CountryName":"Nepal","ISO_2Code":"NP","ISO_3Code":"NPL"},{"CountryCode":"+31","CountryName":"Netherlands","ISO_2Code":"NL","ISO_3Code":"NLD"},{"CountryCode":"+687","CountryName":"New Caledonia","ISO_2Code":"NC","ISO_3Code":"NCL"},{"CountryCode":"+64","CountryName":"New Zealand","ISO_2Code":"NZ","ISO_3Code":"NZL"},{"CountryCode":"+234","CountryName":"Nigeria","ISO_2Code":"NG","ISO_3Code":"NGA"},{"CountryCode":"+47","CountryName":"Norway","ISO_2Code":"NO","ISO_3Code":"NOR"},{"CountryCode":"+968","CountryName":"Oman","ISO_2Code":"OM","ISO_3Code":"OMN"},{"CountryCode":"+92","CountryName":"Pakistan","ISO_2Code":"PK","ISO_3Code":"PAK"},{"CountryCode":"+970","CountryName":"Palestine","ISO_2Code":"PS","ISO_3Code":"PSE"},{"CountryCode":"+507","CountryName":"Panama","ISO_2Code":"PA","ISO_3Code":"PAN"},{"CountryCode":"+595","CountryName":"Paraguay","ISO_2Code":"PY","ISO_3Code":"PRY"},{"CountryCode":"+51","CountryName":"Peru","ISO_2Code":"PE","ISO_3Code":"PER"},{"CountryCode":"+63","CountryName":"Philippines","ISO_2Code":"PH","ISO_3Code":"PHL"},{"CountryCode":"+48","CountryName":"Poland","ISO_2Code":"PL","ISO_3Code":"POL"},{"CountryCode":"+351","CountryName":"Portugal","ISO_2Code":"PT","ISO_3Code":"PRT"},{"CountryCode":"+1","CountryName":"Puerto Rico","ISO_2Code":"PR","ISO_3Code":"PRI"},{"CountryCode":"+974","CountryName":"Qatar","ISO_2Code":"QA","ISO_3Code":"QAT"},{"CountryCode":"+262","CountryName":"Réunion","ISO_2Code":"RE","ISO_3Code":"REU"},{"CountryCode":"+40","CountryName":"Romania","ISO_2Code":"RO","ISO_3Code":"ROU"},{"CountryCode":"+7","CountryName":"Russia","ISO_2Code":"RU","ISO_3Code":"RUS"},{"CountryCode":"+966","CountryName":"Saudi Arabia","ISO_2Code":"SA","ISO_3Code":"SAU"},{"CountryCode":"+65","CountryName":"Singapore","ISO_2Code":"SG","ISO_3Code":"SGP"},{"CountryCode":"+421","CountryName":"Slovakia","ISO_2Code":"SK","ISO_3Code":"SVK"},{"CountryCode":"+27","CountryName":"South Africa","ISO_2Code":"ZA","ISO_3Code":"ZAF"},{"CountryCode":"+82","CountryName":"South Korea","ISO_2Code":"KR","ISO_3Code":"KOR"},{"CountryCode":"+34","CountryName":"Spain","ISO_2Code":"ES","ISO_3Code":"ESP"},{"CountryCode":"+94","CountryName":"Sri Lanka","ISO_2Code":"LK","ISO_3Code":"LKA"},{"CountryCode":"+249","CountryName":"Sudan","ISO_2Code":"SD","ISO_3Code":"SDN"},{"CountryCode":"+268","CountryName":"Swaziland","ISO_2Code":"SZ","ISO_3Code":"SWZ"},{"CountryCode":"+46","CountryName":"Sweden","ISO_2Code":"SE","ISO_3Code":"SWE"},{"CountryCode":"+41","CountryName":"Switzerland","ISO_2Code":"CH","ISO_3Code":"CHE"},{"CountryCode":"+963","CountryName":"Syria","ISO_2Code":"SY","ISO_3Code":"SYR"},{"CountryCode":"+886","CountryName":"Taiwan","ISO_2Code":"TW","ISO_3Code":"TWN"},{"CountryCode":"+992","CountryName":"Tajikistan","ISO_2Code":"TJ","ISO_3Code":"TJK"},{"CountryCode":"+112","CountryName":"test Country","ISO_2Code":"2312","ISO_3Code":"123"},{"CountryCode":"+66","CountryName":"Thailand","ISO_2Code":"TH","ISO_3Code":"THA"},{"CountryCode":"+90","CountryName":"Turkey","ISO_2Code":"TR","ISO_3Code":"TUR"},{"CountryCode":"+993","CountryName":"Turkmenistan","ISO_2Code":"TM","ISO_3Code":"TKM"},{"CountryCode":"+44","CountryName":"United Kingdom","ISO_2Code":"GB","ISO_3Code":"GBR"},{"CountryCode":"+1","CountryName":"United States","ISO_2Code":"US","ISO_3Code":"USA"},{"CountryCode":"+598","CountryName":"Uruguay","ISO_2Code":"UY","ISO_3Code":"URY"},{"CountryCode":"+998","CountryName":"Uzbekistan","ISO_2Code":"UZ","ISO_3Code":"UZB"},{"CountryCode":"+84","CountryName":"Vietnam","ISO_2Code":"VN","ISO_3Code":"VNM"},{"CountryCode":"+1","CountryName":"Virgin Islands (U.S.)","ISO_2Code":"VI","ISO_3Code":"VIR"},{"CountryCode":"+967","CountryName":"Yemen","ISO_2Code":"YE","ISO_3Code":"YEM"}];
// let ar_list = [{"CountryCode":"+93","CountryName":"افغانستان","ISO_2Code":"AF","ISO_3Code":"AFG"},{"CountryCode":"+376","CountryName":"أندورا","ISO_2Code":"AD","ISO_3Code":"AND"},{"CountryCode":"+61","CountryName":"أستراليا","ISO_2Code":"AU","ISO_3Code":"AUS"},{"CountryCode":"+43","CountryName":"النمسا","ISO_2Code":"AT","ISO_3Code":"AUT"},{"CountryCode":"+1","CountryName":"الباهاماس","ISO_2Code":"BS","ISO_3Code":"BHS"},{"CountryCode":"+973","CountryName":"البحرين","ISO_2Code":"BH","ISO_3Code":"BHR"},{"CountryCode":"+880","CountryName":"بنغلاديش","ISO_2Code":"BD","ISO_3Code":"BGD"},{"CountryCode":"+32","CountryName":"بلجيكا","ISO_2Code":"BE","ISO_3Code":"BEL"},{"CountryCode":"+1","CountryName":"جزر برمودا","ISO_2Code":"BM","ISO_3Code":"BMU"},{"CountryCode":"+975","CountryName":"بوتان","ISO_2Code":"BT","ISO_3Code":"BTN"},{"CountryCode":"+55","CountryName":"البرازيل","ISO_2Code":"BR","ISO_3Code":"BRA"},{"CountryCode":"+673","CountryName":"Brunei Darussalam","ISO_2Code":"BN","ISO_3Code":"BRN"},{"CountryCode":"+855","CountryName":"كمبوديا","ISO_2Code":"KH","ISO_3Code":"KHM"},{"CountryCode":"+1","CountryName":"كندا","ISO_2Code":"CA","ISO_3Code":"CAN"},{"CountryCode":"+86","CountryName":"الصين","ISO_2Code":"CN","ISO_3Code":"CHN"},{"CountryCode":"+57","CountryName":"كولومبيا","ISO_2Code":"CO","ISO_3Code":"COL"},{"CountryCode":"+506","CountryName":"كوستاريكا","ISO_2Code":"CR","ISO_3Code":"CRI"},{"CountryCode":"+357","CountryName":"قبرص","ISO_2Code":"CY","ISO_3Code":"CYP"},{"CountryCode":"+420","CountryName":"الجمهورية التشيكية","ISO_2Code":"CZ","ISO_3Code":"CZE"},{"CountryCode":"+45","CountryName":"الدانمارك","ISO_2Code":"DK","ISO_3Code":"DNK"},{"CountryCode":"+1","CountryName":"الدومينيكان","ISO_2Code":"DO","ISO_3Code":"DOM"},{"CountryCode":"+20","CountryName":"مصر","ISO_2Code":"EG","ISO_3Code":"EGY"},{"CountryCode":"+503","CountryName":"إلسلفادور","ISO_2Code":"SV","ISO_3Code":"SLV"},{"CountryCode":"+298","CountryName":"جزر فارو","ISO_2Code":"FO","ISO_3Code":"FRO"},{"CountryCode":"+358","CountryName":"فنلندا","ISO_2Code":"FI","ISO_3Code":"FIN"},{"CountryCode":"+33","CountryName":"فرنسا","ISO_2Code":"FR","ISO_3Code":"FRA"},{"CountryCode":"+594","CountryName":"غويانا الفرنسية","ISO_2Code":"GF","ISO_3Code":"GUF"},{"CountryCode":"+49","CountryName":"ألمانيا","ISO_2Code":"DE","ISO_3Code":"DEU"},{"CountryCode":"+350","CountryName":"جبل طارق","ISO_2Code":"GI","ISO_3Code":"GIB"},{"CountryCode":"+30","CountryName":"اليونان","ISO_2Code":"GR","ISO_3Code":"GRC"},{"CountryCode":"+590","CountryName":"جزر جوادلوب","ISO_2Code":"GP","ISO_3Code":"GLP"},{"CountryCode":"+1","CountryName":"جوام","ISO_2Code":"GU","ISO_3Code":"GUM"},{"CountryCode":"+502","CountryName":"غواتيمال","ISO_2Code":"GT","ISO_3Code":"GTM"},{"CountryCode":"+592","CountryName":"غيانا","ISO_2Code":"GY","ISO_3Code":"GUY"},{"CountryCode":"+852","CountryName":"هونغ كونغ","ISO_2Code":"HK","ISO_3Code":"HKG"},{"CountryCode":"+36","CountryName":"المجر","ISO_2Code":"HU","ISO_3Code":"HUN"},{"CountryCode":"+354","CountryName":"آيسلندا","ISO_2Code":"IS","ISO_3Code":"ISL"},{"CountryCode":"+91","CountryName":"الهند","ISO_2Code":"IN","ISO_3Code":"IND"},{"CountryCode":"+62","CountryName":"أندونيسيا","ISO_2Code":"ID","ISO_3Code":"IDN"},{"CountryCode":"+98","CountryName":"إيران","ISO_2Code":"IR","ISO_3Code":"IRN"},{"CountryCode":"+353","CountryName":"أيرلندا","ISO_2Code":"IE","ISO_3Code":"IRL"},{"CountryCode":"+39","CountryName":"إيطاليا","ISO_2Code":"IT","ISO_3Code":"ITA"},{"CountryCode":"+81","CountryName":"اليابان","ISO_2Code":"JP","ISO_3Code":"JPN"},{"CountryCode":"+962","CountryName":"الأردن","ISO_2Code":"JO","ISO_3Code":"JOR"},{"CountryCode":"+254","CountryName":"كينيا","ISO_2Code":"KE","ISO_3Code":"KEN"},{"CountryCode":"+965","CountryName":"الكويت","ISO_2Code":"KW","ISO_3Code":"KWT"},{"CountryCode":"+856","CountryName":"Lao People's Democratic Republic","ISO_2Code":"LA","ISO_3Code":"LAO"},{"CountryCode":"+961","CountryName":"لبنان","ISO_2Code":"LB","ISO_3Code":"LBN"},{"CountryCode":"+352","CountryName":"لوكسمبورغ","ISO_2Code":"LU","ISO_3Code":"LUX"},{"CountryCode":"+853","CountryName":"ماكاو","ISO_2Code":"MO","ISO_3Code":"MAC"},{"CountryCode":"+60","CountryName":"ماليزيا","ISO_2Code":"MY","ISO_3Code":"MYS"},{"CountryCode":"+356","CountryName":"مالطا","ISO_2Code":"MT","ISO_3Code":"MLT"},{"CountryCode":"+692","CountryName":"جزر مارشال","ISO_2Code":"MH","ISO_3Code":"MHL"},{"CountryCode":"+596","CountryName":"مارتينيك","ISO_2Code":"MQ","ISO_3Code":"MTQ"},{"CountryCode":"+230","CountryName":"موريشيوس","ISO_2Code":"MU","ISO_3Code":"MUS"},{"CountryCode":"+262","CountryName":"مايوتي","ISO_2Code":"YT","ISO_3Code":"MYT"},{"CountryCode":"+52","CountryName":"المكسيك","ISO_2Code":"MX","ISO_3Code":"MEX"},{"CountryCode":"+976","CountryName":"منغوليا","ISO_2Code":"MN","ISO_3Code":"MNG"},{"CountryCode":"+264","CountryName":"ناميبيا","ISO_2Code":"NA","ISO_3Code":"NAM"},{"CountryCode":"+977","CountryName":"نيبال","ISO_2Code":"NP","ISO_3Code":"NPL"},{"CountryCode":"+31","CountryName":"هولندا","ISO_2Code":"NL","ISO_3Code":"NLD"},{"CountryCode":"+687","CountryName":"New Caledonia","ISO_2Code":"NC","ISO_3Code":"NCL"},{"CountryCode":"+64","CountryName":"نيوزيلندا","ISO_2Code":"NZ","ISO_3Code":"NZL"},{"CountryCode":"+234","CountryName":"نيجيريا","ISO_2Code":"NG","ISO_3Code":"NGA"},{"CountryCode":"+47","CountryName":"النرويج","ISO_2Code":"NO","ISO_3Code":"NOR"},{"CountryCode":"+968","CountryName":"عُمان","ISO_2Code":"OM","ISO_3Code":"OMN"},{"CountryCode":"+92","CountryName":"باكستان","ISO_2Code":"PK","ISO_3Code":"PAK"},{"CountryCode":"+970","CountryName":"فلسطين","ISO_2Code":"PS","ISO_3Code":"PSE"},{"CountryCode":"+507","CountryName":"بنما","ISO_2Code":"PA","ISO_3Code":"PAN"},{"CountryCode":"+595","CountryName":"باراغواي","ISO_2Code":"PY","ISO_3Code":"PRY"},{"CountryCode":"+51","CountryName":"بيرو","ISO_2Code":"PE","ISO_3Code":"PER"},{"CountryCode":"+63","CountryName":"الفليبين","ISO_2Code":"PH","ISO_3Code":"PHL"},{"CountryCode":"+48","CountryName":"بولندا","ISO_2Code":"PL","ISO_3Code":"POL"},{"CountryCode":"+351","CountryName":"البرتغال","ISO_2Code":"PT","ISO_3Code":"PRT"},{"CountryCode":"+1","CountryName":"بورتوريكو","ISO_2Code":"PR","ISO_3Code":"PRI"},{"CountryCode":"+974","CountryName":"قطر","ISO_2Code":"QA","ISO_3Code":"QAT"},{"CountryCode":"+262","CountryName":"Réunion","ISO_2Code":"RE","ISO_3Code":"REU"},{"CountryCode":"+40","CountryName":"رومانيا","ISO_2Code":"RO","ISO_3Code":"ROU"},{"CountryCode":"+7","CountryName":"Russia","ISO_2Code":"RU","ISO_3Code":"RUS"},{"CountryCode":"+966","CountryName":"المملكة العربية السعودية","ISO_2Code":"SA","ISO_3Code":"SAU"},{"CountryCode":"+65","CountryName":"سنغافورة","ISO_2Code":"SG","ISO_3Code":"SGP"},{"CountryCode":"+421","CountryName":"سلوفاكيا","ISO_2Code":"SK","ISO_3Code":"SVK"},{"CountryCode":"+27","CountryName":"جنوب أفريقيا","ISO_2Code":"ZA","ISO_3Code":"ZAF"},{"CountryCode":"+82","CountryName":"كوريا الجنوبية","ISO_2Code":"KR","ISO_3Code":"KOR"},{"CountryCode":"+34","CountryName":"إسبانيا","ISO_2Code":"ES","ISO_3Code":"ESP"},{"CountryCode":"+94","CountryName":"سريلانكا","ISO_2Code":"LK","ISO_3Code":"LKA"},{"CountryCode":"+249","CountryName":"السودان","ISO_2Code":"SD","ISO_3Code":"SDN"},{"CountryCode":"+268","CountryName":"سوازيلند","ISO_2Code":"SZ","ISO_3Code":"SWZ"},{"CountryCode":"+46","CountryName":"السويد","ISO_2Code":"SE","ISO_3Code":"SWE"},{"CountryCode":"+41","CountryName":"سويسرا","ISO_2Code":"CH","ISO_3Code":"CHE"},{"CountryCode":"+963","CountryName":"سوريا","ISO_2Code":"SY","ISO_3Code":"SYR"},{"CountryCode":"+886","CountryName":"تايوان","ISO_2Code":"TW","ISO_3Code":"TWN"},{"CountryCode":"+992","CountryName":"طاجيكستان","ISO_2Code":"TJ","ISO_3Code":"TJK"},{"CountryCode":"+112","CountryName":"test Country","ISO_2Code":"2312","ISO_3Code":"123"},{"CountryCode":"+66","CountryName":"تايلاند","ISO_2Code":"TH","ISO_3Code":"THA"},{"CountryCode":"+90","CountryName":"ديك رومي","ISO_2Code":"TR","ISO_3Code":"TUR"},{"CountryCode":"+993","CountryName":"تركمانستان","ISO_2Code":"TM","ISO_3Code":"TKM"},{"CountryCode":"+44","CountryName":"المملكة المتحدة","ISO_2Code":"GB","ISO_3Code":"GBR"},{"CountryCode":"+1","CountryName":"الولايات المتحدة","ISO_2Code":"US","ISO_3Code":"USA"},{"CountryCode":"+598","CountryName":"أوروغواي","ISO_2Code":"UY","ISO_3Code":"URY"},{"CountryCode":"+998","CountryName":"أوزبكستان","ISO_2Code":"UZ","ISO_3Code":"UZB"},{"CountryCode":"+84","CountryName":"Vietnam","ISO_2Code":"VN","ISO_3Code":"VNM"},{"CountryCode":"+1","CountryName":"Virgin Islands (U.S.)","ISO_2Code":"VI","ISO_3Code":"VIR"},{"CountryCode":"+967","CountryName":"اليمن","ISO_2Code":"YE","ISO_3Code":"YEM"}];

let CountriesList = {
  AF: {
    CountryCode: "+93",
    CountryName: "Afghanistan",
    ISO_2Code: "AF",
    ISO_3Code: "AFG",
    CountryName_ar: "افغانستان",
  },
  AD: {
    CountryCode: "+376",
    CountryName: "Andorra",
    ISO_2Code: "AD",
    ISO_3Code: "AND",
    CountryName_ar: "أندورا",
  },
  AE: {
    CountryCode: "+971",
    CountryName: "United Arab Emirates",
    ISO_2Code: "AE",
    ISO_3Code: "ARE",
    CountryName_ar: "الإمارات العربية المتحدة",
  },
  AU: {
    CountryCode: "+61",
    CountryName: "Australia",
    ISO_2Code: "AU",
    ISO_3Code: "AUS",
    CountryName_ar: "أستراليا",
  },
  AT: {
    CountryCode: "+43",
    CountryName: "Austria",
    ISO_2Code: "AT",
    ISO_3Code: "AUT",
    CountryName_ar: "النمسا",
  },
  BS: {
    CountryCode: "+1",
    CountryName: "Bahamas",
    ISO_2Code: "BS",
    ISO_3Code: "BHS",
    CountryName_ar: "الباهاماس",
  },
  BH: {
    CountryCode: "+973",
    CountryName: "Bahrain",
    ISO_2Code: "BH",
    ISO_3Code: "BHR",
    CountryName_ar: "البحرين",
  },
  BD: {
    CountryCode: "+880",
    CountryName: "Bangladesh",
    ISO_2Code: "BD",
    ISO_3Code: "BGD",
    CountryName_ar: "بنغلاديش",
  },
  BE: {
    CountryCode: "+32",
    CountryName: "Belgium",
    ISO_2Code: "BE",
    ISO_3Code: "BEL",
    CountryName_ar: "بلجيكا",
  },
  BM: {
    CountryCode: "+1",
    CountryName: "Bermuda",
    ISO_2Code: "BM",
    ISO_3Code: "BMU",
    CountryName_ar: "جزر برمودا",
  },
  BT: {
    CountryCode: "+975",
    CountryName: "Bhutan",
    ISO_2Code: "BT",
    ISO_3Code: "BTN",
    CountryName_ar: "بوتان",
  },
  BR: {
    CountryCode: "+55",
    CountryName: "Brazil",
    ISO_2Code: "BR",
    ISO_3Code: "BRA",
    CountryName_ar: "البرازيل",
  },
  BN: {
    CountryCode: "+673",
    CountryName: "Brunei Darussalam",
    ISO_2Code: "BN",
    ISO_3Code: "BRN",
    CountryName_ar: "Brunei Darussalam",
  },
  KH: {
    CountryCode: "+855",
    CountryName: "Cambodia",
    ISO_2Code: "KH",
    ISO_3Code: "KHM",
    CountryName_ar: "كمبوديا",
  },
  CA: {
    CountryCode: "+1",
    CountryName: "Canada",
    ISO_2Code: "CA",
    ISO_3Code: "CAN",
    CountryName_ar: "كندا",
  },
  CN: {
    CountryCode: "+86",
    CountryName: "China",
    ISO_2Code: "CN",
    ISO_3Code: "CHN",
    CountryName_ar: "الصين",
  },
  CO: {
    CountryCode: "+57",
    CountryName: "Colombia",
    ISO_2Code: "CO",
    ISO_3Code: "COL",
    CountryName_ar: "كولومبيا",
  },
  CR: {
    CountryCode: "+506",
    CountryName: "Costa Rica",
    ISO_2Code: "CR",
    ISO_3Code: "CRI",
    CountryName_ar: "كوستاريكا",
  },
  CY: {
    CountryCode: "+357",
    CountryName: "Cyprus",
    ISO_2Code: "CY",
    ISO_3Code: "CYP",
    CountryName_ar: "قبرص",
  },
  CZ: {
    CountryCode: "+420",
    CountryName: "Czech Republic",
    ISO_2Code: "CZ",
    ISO_3Code: "CZE",
    CountryName_ar: "الجمهورية التشيكية",
  },
  DK: {
    CountryCode: "+45",
    CountryName: "Denmark",
    ISO_2Code: "DK",
    ISO_3Code: "DNK",
    CountryName_ar: "الدانمارك",
  },
  DO: {
    CountryCode: "+1",
    CountryName: "Dominican Republic",
    ISO_2Code: "DO",
    ISO_3Code: "DOM",
    CountryName_ar: "الدومينيكان",
  },
  EG: {
    CountryCode: "+20",
    CountryName: "Egypt",
    ISO_2Code: "EG",
    ISO_3Code: "EGY",
    CountryName_ar: "مصر",
  },
  SV: {
    CountryCode: "+503",
    CountryName: "El Salvador",
    ISO_2Code: "SV",
    ISO_3Code: "SLV",
    CountryName_ar: "إلسلفادور",
  },
  FO: {
    CountryCode: "+298",
    CountryName: "Faroe Islands",
    ISO_2Code: "FO",
    ISO_3Code: "FRO",
    CountryName_ar: "جزر فارو",
  },
  FI: {
    CountryCode: "+358",
    CountryName: "Finland",
    ISO_2Code: "FI",
    ISO_3Code: "FIN",
    CountryName_ar: "فنلندا",
  },
  FR: {
    CountryCode: "+33",
    CountryName: "France",
    ISO_2Code: "FR",
    ISO_3Code: "FRA",
    CountryName_ar: "فرنسا",
  },
  GF: {
    CountryCode: "+594",
    CountryName: "French Guiana",
    ISO_2Code: "GF",
    ISO_3Code: "GUF",
    CountryName_ar: "غويانا الفرنسية",
  },
  DE: {
    CountryCode: "+49",
    CountryName: "Germany",
    ISO_2Code: "DE",
    ISO_3Code: "DEU",
    CountryName_ar: "ألمانيا",
  },
  GI: {
    CountryCode: "+350",
    CountryName: "Gibraltar",
    ISO_2Code: "GI",
    ISO_3Code: "GIB",
    CountryName_ar: "جبل طارق",
  },
  GR: {
    CountryCode: "+30",
    CountryName: "Greece",
    ISO_2Code: "GR",
    ISO_3Code: "GRC",
    CountryName_ar: "اليونان",
  },
  GP: {
    CountryCode: "+590",
    CountryName: "Guadeloupe",
    ISO_2Code: "GP",
    ISO_3Code: "GLP",
    CountryName_ar: "جزر جوادلوب",
  },
  GU: {
    CountryCode: "+1",
    CountryName: "Guam",
    ISO_2Code: "GU",
    ISO_3Code: "GUM",
    CountryName_ar: "جوام",
  },
  GT: {
    CountryCode: "+502",
    CountryName: "Guatemala",
    ISO_2Code: "GT",
    ISO_3Code: "GTM",
    CountryName_ar: "غواتيمال",
  },
  GY: {
    CountryCode: "+592",
    CountryName: "Guyana",
    ISO_2Code: "GY",
    ISO_3Code: "GUY",
    CountryName_ar: "غيانا",
  },
  HK: {
    CountryCode: "+852",
    CountryName: "Hong Kong",
    ISO_2Code: "HK",
    ISO_3Code: "HKG",
    CountryName_ar: "هونغ كونغ",
  },
  HU: {
    CountryCode: "+36",
    CountryName: "Hungary",
    ISO_2Code: "HU",
    ISO_3Code: "HUN",
    CountryName_ar: "المجر",
  },
  IS: {
    CountryCode: "+354",
    CountryName: "Iceland",
    ISO_2Code: "IS",
    ISO_3Code: "ISL",
    CountryName_ar: "آيسلندا",
  },
  IN: {
    CountryCode: "+91",
    CountryName: "India",
    ISO_2Code: "IN",
    ISO_3Code: "IND",
    CountryName_ar: "الهند",
  },
  ID: {
    CountryCode: "+62",
    CountryName: "Indonesia",
    ISO_2Code: "ID",
    ISO_3Code: "IDN",
    CountryName_ar: "أندونيسيا",
  },
  IR: {
    CountryCode: "+98",
    CountryName: "Iran",
    ISO_2Code: "IR",
    ISO_3Code: "IRN",
    CountryName_ar: "إيران",
  },
  IE: {
    CountryCode: "+353",
    CountryName: "Ireland",
    ISO_2Code: "IE",
    ISO_3Code: "IRL",
    CountryName_ar: "أيرلندا",
  },
  IT: {
    CountryCode: "+39",
    CountryName: "Italy",
    ISO_2Code: "IT",
    ISO_3Code: "ITA",
    CountryName_ar: "إيطاليا",
  },
  JP: {
    CountryCode: "+81",
    CountryName: "Japan",
    ISO_2Code: "JP",
    ISO_3Code: "JPN",
    CountryName_ar: "اليابان",
  },
  JO: {
    CountryCode: "+962",
    CountryName: "Jordan",
    ISO_2Code: "JO",
    ISO_3Code: "JOR",
    CountryName_ar: "الأردن",
  },
  KE: {
    CountryCode: "+254",
    CountryName: "Kenya",
    ISO_2Code: "KE",
    ISO_3Code: "KEN",
    CountryName_ar: "كينيا",
  },
  KW: {
    CountryCode: "+965",
    CountryName: "Kuwait",
    ISO_2Code: "KW",
    ISO_3Code: "KWT",
    CountryName_ar: "الكويت",
  },
  LA: {
    CountryCode: "+856",
    CountryName: "Lao People's Democratic Republic",
    ISO_2Code: "LA",
    ISO_3Code: "LAO",
    CountryName_ar: "Lao People's Democratic Republic",
  },
  LB: {
    CountryCode: "+961",
    CountryName: "Lebanon",
    ISO_2Code: "LB",
    ISO_3Code: "LBN",
    CountryName_ar: "لبنان",
  },
  LU: {
    CountryCode: "+352",
    CountryName: "Luxembourg",
    ISO_2Code: "LU",
    ISO_3Code: "LUX",
    CountryName_ar: "لوكسمبورغ",
  },
  MO: {
    CountryCode: "+853",
    CountryName: "Macao",
    ISO_2Code: "MO",
    ISO_3Code: "MAC",
    CountryName_ar: "ماكاو",
  },
  MY: {
    CountryCode: "+60",
    CountryName: "Malaysia",
    ISO_2Code: "MY",
    ISO_3Code: "MYS",
    CountryName_ar: "ماليزيا",
  },
  MT: {
    CountryCode: "+356",
    CountryName: "Malta",
    ISO_2Code: "MT",
    ISO_3Code: "MLT",
    CountryName_ar: "مالطا",
  },
  MH: {
    CountryCode: "+692",
    CountryName: "Marshall Islands",
    ISO_2Code: "MH",
    ISO_3Code: "MHL",
    CountryName_ar: "جزر مارشال",
  },
  MQ: {
    CountryCode: "+596",
    CountryName: "Martinique",
    ISO_2Code: "MQ",
    ISO_3Code: "MTQ",
    CountryName_ar: "مارتينيك",
  },
  MU: {
    CountryCode: "+230",
    CountryName: "Mauritius",
    ISO_2Code: "MU",
    ISO_3Code: "MUS",
    CountryName_ar: "موريشيوس",
  },
  YT: {
    CountryCode: "+262",
    CountryName: "Mayotte",
    ISO_2Code: "YT",
    ISO_3Code: "MYT",
    CountryName_ar: "مايوتي",
  },
  MX: {
    CountryCode: "+52",
    CountryName: "Mexico",
    ISO_2Code: "MX",
    ISO_3Code: "MEX",
    CountryName_ar: "المكسيك",
  },
  MN: {
    CountryCode: "+976",
    CountryName: "Mongolia",
    ISO_2Code: "MN",
    ISO_3Code: "MNG",
    CountryName_ar: "منغوليا",
  },
  NA: {
    CountryCode: "+264",
    CountryName: "Namibia",
    ISO_2Code: "NA",
    ISO_3Code: "NAM",
    CountryName_ar: "ناميبيا",
  },
  NP: {
    CountryCode: "+977",
    CountryName: "Nepal",
    ISO_2Code: "NP",
    ISO_3Code: "NPL",
    CountryName_ar: "نيبال",
  },
  NL: {
    CountryCode: "+31",
    CountryName: "Netherlands",
    ISO_2Code: "NL",
    ISO_3Code: "NLD",
    CountryName_ar: "هولندا",
  },
  NC: {
    CountryCode: "+687",
    CountryName: "New Caledonia",
    ISO_2Code: "NC",
    ISO_3Code: "NCL",
    CountryName_ar: "New Caledonia",
  },
  NZ: {
    CountryCode: "+64",
    CountryName: "New Zealand",
    ISO_2Code: "NZ",
    ISO_3Code: "NZL",
    CountryName_ar: "نيوزيلندا",
  },
  NG: {
    CountryCode: "+234",
    CountryName: "Nigeria",
    ISO_2Code: "NG",
    ISO_3Code: "NGA",
    CountryName_ar: "نيجيريا",
  },
  NO: {
    CountryCode: "+47",
    CountryName: "Norway",
    ISO_2Code: "NO",
    ISO_3Code: "NOR",
    CountryName_ar: "النرويج",
  },
  OM: {
    CountryCode: "+968",
    CountryName: "Oman",
    ISO_2Code: "OM",
    ISO_3Code: "OMN",
    CountryName_ar: "عُمان",
  },
  PK: {
    CountryCode: "+92",
    CountryName: "Pakistan",
    ISO_2Code: "PK",
    ISO_3Code: "PAK",
    CountryName_ar: "باكستان",
  },
  PS: {
    CountryCode: "+970",
    CountryName: "Palestine",
    ISO_2Code: "PS",
    ISO_3Code: "PSE",
    CountryName_ar: "فلسطين",
  },
  PA: {
    CountryCode: "+507",
    CountryName: "Panama",
    ISO_2Code: "PA",
    ISO_3Code: "PAN",
    CountryName_ar: "بنما",
  },
  PY: {
    CountryCode: "+595",
    CountryName: "Paraguay",
    ISO_2Code: "PY",
    ISO_3Code: "PRY",
    CountryName_ar: "باراغواي",
  },
  PE: {
    CountryCode: "+51",
    CountryName: "Peru",
    ISO_2Code: "PE",
    ISO_3Code: "PER",
    CountryName_ar: "بيرو",
  },
  PH: {
    CountryCode: "+63",
    CountryName: "Philippines",
    ISO_2Code: "PH",
    ISO_3Code: "PHL",
    CountryName_ar: "الفليبين",
  },
  PL: {
    CountryCode: "+48",
    CountryName: "Poland",
    ISO_2Code: "PL",
    ISO_3Code: "POL",
    CountryName_ar: "بولندا",
  },
  PT: {
    CountryCode: "+351",
    CountryName: "Portugal",
    ISO_2Code: "PT",
    ISO_3Code: "PRT",
    CountryName_ar: "البرتغال",
  },
  PR: {
    CountryCode: "+1",
    CountryName: "Puerto Rico",
    ISO_2Code: "PR",
    ISO_3Code: "PRI",
    CountryName_ar: "بورتوريكو",
  },
  QA: {
    CountryCode: "+974",
    CountryName: "Qatar",
    ISO_2Code: "QA",
    ISO_3Code: "QAT",
    CountryName_ar: "قطر",
  },
  RE: {
    CountryCode: "+262",
    CountryName: "Réunion",
    ISO_2Code: "RE",
    ISO_3Code: "REU",
    CountryName_ar: "Réunion",
  },
  RO: {
    CountryCode: "+40",
    CountryName: "Romania",
    ISO_2Code: "RO",
    ISO_3Code: "ROU",
    CountryName_ar: "رومانيا",
  },
  RU: {
    CountryCode: "+7",
    CountryName: "Russia",
    ISO_2Code: "RU",
    ISO_3Code: "RUS",
    CountryName_ar: "Russia",
  },
  SA: {
    CountryCode: "+966",
    CountryName: "Saudi Arabia",
    ISO_2Code: "SA",
    ISO_3Code: "SAU",
    CountryName_ar: "المملكة العربية السعودية",
  },
  SG: {
    CountryCode: "+65",
    CountryName: "Singapore",
    ISO_2Code: "SG",
    ISO_3Code: "SGP",
    CountryName_ar: "سنغافورة",
  },
  SK: {
    CountryCode: "+421",
    CountryName: "Slovakia",
    ISO_2Code: "SK",
    ISO_3Code: "SVK",
    CountryName_ar: "سلوفاكيا",
  },
  ZA: {
    CountryCode: "+27",
    CountryName: "South Africa",
    ISO_2Code: "ZA",
    ISO_3Code: "ZAF",
    CountryName_ar: "جنوب أفريقيا",
  },
  KR: {
    CountryCode: "+82",
    CountryName: "South Korea",
    ISO_2Code: "KR",
    ISO_3Code: "KOR",
    CountryName_ar: "كوريا الجنوبية",
  },
  ES: {
    CountryCode: "+34",
    CountryName: "Spain",
    ISO_2Code: "ES",
    ISO_3Code: "ESP",
    CountryName_ar: "إسبانيا",
  },
  LK: {
    CountryCode: "+94",
    CountryName: "Sri Lanka",
    ISO_2Code: "LK",
    ISO_3Code: "LKA",
    CountryName_ar: "سريلانكا",
  },
  SD: {
    CountryCode: "+249",
    CountryName: "Sudan",
    ISO_2Code: "SD",
    ISO_3Code: "SDN",
    CountryName_ar: "السودان",
  },
  SZ: {
    CountryCode: "+268",
    CountryName: "Swaziland",
    ISO_2Code: "SZ",
    ISO_3Code: "SWZ",
    CountryName_ar: "سوازيلند",
  },
  SE: {
    CountryCode: "+46",
    CountryName: "Sweden",
    ISO_2Code: "SE",
    ISO_3Code: "SWE",
    CountryName_ar: "السويد",
  },
  CH: {
    CountryCode: "+41",
    CountryName: "Switzerland",
    ISO_2Code: "CH",
    ISO_3Code: "CHE",
    CountryName_ar: "سويسرا",
  },
  SY: {
    CountryCode: "+963",
    CountryName: "Syria",
    ISO_2Code: "SY",
    ISO_3Code: "SYR",
    CountryName_ar: "سوريا",
  },
  TW: {
    CountryCode: "+886",
    CountryName: "Taiwan",
    ISO_2Code: "TW",
    ISO_3Code: "TWN",
    CountryName_ar: "تايوان",
  },
  TJ: {
    CountryCode: "+992",
    CountryName: "Tajikistan",
    ISO_2Code: "TJ",
    ISO_3Code: "TJK",
    CountryName_ar: "طاجيكستان",
  },
  TH: {
    CountryCode: "+66",
    CountryName: "Thailand",
    ISO_2Code: "TH",
    ISO_3Code: "THA",
    CountryName_ar: "تايلاند",
  },
  TR: {
    CountryCode: "+90",
    CountryName: "Turkey",
    ISO_2Code: "TR",
    ISO_3Code: "TUR",
    CountryName_ar: "ديك رومي",
  },
  TM: {
    CountryCode: "+993",
    CountryName: "Turkmenistan",
    ISO_2Code: "TM",
    ISO_3Code: "TKM",
    CountryName_ar: "تركمانستان",
  },
  GB: {
    CountryCode: "+44",
    CountryName: "United Kingdom",
    ISO_2Code: "GB",
    ISO_3Code: "GBR",
    CountryName_ar: "المملكة المتحدة",
  },
  US: {
    CountryCode: "+1",
    CountryName: "United States",
    ISO_2Code: "US",
    ISO_3Code: "USA",
    CountryName_ar: "الولايات المتحدة",
  },
  UY: {
    CountryCode: "+598",
    CountryName: "Uruguay",
    ISO_2Code: "UY",
    ISO_3Code: "URY",
    CountryName_ar: "أوروغواي",
  },
  UZ: {
    CountryCode: "+998",
    CountryName: "Uzbekistan",
    ISO_2Code: "UZ",
    ISO_3Code: "UZB",
    CountryName_ar: "أوزبكستان",
  },
  VN: {
    CountryCode: "+84",
    CountryName: "Vietnam",
    ISO_2Code: "VN",
    ISO_3Code: "VNM",
    CountryName_ar: "Vietnam",
  },
  VI: {
    CountryCode: "+1",
    CountryName: "Virgin Islands (U.S.)",
    ISO_2Code: "VI",
    ISO_3Code: "VIR",
    CountryName_ar: "Virgin Islands (U.S.)",
  },
  YE: {
    CountryCode: "+967",
    CountryName: "Yemen",
    ISO_2Code: "YE",
    ISO_3Code: "YEM",
    CountryName_ar: "اليمن",
  },
};
// let CountriesListEN = Helpers.arrayToObject(en_list, "ISO_2Code");
// let CountriesListAR = Helpers.arrayToObject(ar_list, "ISO_2Code");

let sortedCountryCodes = Object.keys(CountriesList);
// let CountriesList = {...CountriesListEN};
// for(let code of sortedCountryCodes){
// 	CountriesList[code]['CountryName_ar'] = CountriesListAR[code]['CountryName'];
// }
// let CountriesList = {"1": { iso2: "us", code: "1", name: "United States" }, "7": { iso2: "ru", code: "7", name: "Russia (Россия)" }, "20": { iso2: "eg", code: "20", name: "Egypt (‫مصر‬‎)" }, "27": { iso2: "za", code: "27", name: "South Africa" }, "30": { iso2: "gr", code: "30", name: "Greece (Ελλάδα)" }, "31": { iso2: "nl", code: "31", name: "Netherlands (Nederland)" }, "32": { iso2: "be", code: "32", name: "Belgium (België)" }, "33": { iso2: "fr", code: "33", name: "France" }, "34": { iso2: "es", code: "34", name: "Spain (España)" }, "36": { iso2: "hu", code: "36", name: "Hungary (Magyarország)" }, "39": { iso2: "va", code: "39", name: "Vatican City (Città del Vaticano)" }, "40": { iso2: "ro", code: "40", name: "Romania (România)" }, "41": { iso2: "ch", code: "41", name: "Switzerland (Schweiz)" }, "43": { iso2: "at", code: "43", name: "Austria (Österreich)" }, "44": { iso2: "gb", code: "44", name: "United Kingdom" }, "45": { iso2: "dk", code: "45", name: "Denmark (Danmark)" }, "46": { iso2: "se", code: "46", name: "Sweden (Sverige)" }, "47": { iso2: "sj", code: "47", name: "Svalbard and Jan Mayen" }, "48": { iso2: "pl", code: "48", name: "Poland (Polska)" }, "49": { iso2: "de", code: "49", name: "Germany (Deutschland)" }, "51": { iso2: "pe", code: "51", name: "Peru (Perú)" }, "52": { iso2: "mx", code: "52", name: "Mexico (México)" }, "53": { iso2: "cu", code: "53", name: "Cuba" }, "54": { iso2: "ar", code: "54", name: "Argentina" }, "55": { iso2: "br", code: "55", name: "Brazil (Brasil)" }, "56": { iso2: "cl", code: "56", name: "Chile" }, "57": { iso2: "co", code: "57", name: "Colombia" }, "58": { iso2: "ve", code: "58", name: "Venezuela" }, "60": { iso2: "my", code: "60", name: "Malaysia" }, "61": { iso2: "cc", code: "61", name: "Cocos (Keeling) Islands" }, "62": { iso2: "id", code: "62", name: "Indonesia" }, "63": { iso2: "ph", code: "63", name: "Philippines" }, "64": { iso2: "nz", code: "64", name: "New Zealand" }, "65": { iso2: "sg", code: "65", name: "Singapore" }, "66": { iso2: "th", code: "66", name: "Thailand (ไทย)" }, "81": { iso2: "jp", code: "81", name: "Japan (日本)" }, "82": { iso2: "kr", code: "82", name: "South Korea (대한민국)" }, "84": { iso2: "vn", code: "84", name: "Vietnam (Việt Nam)" }, "86": { iso2: "cn", code: "86", name: "China (中国)" }, "90": { iso2: "tr", code: "90", name: "Turkey (Türkiye)" }, "91": { iso2: "in", code: "91", name: "India (भारत)" }, "92": { iso2: "pk", code: "92", name: "Pakistan (‫پاکستان‬‎)" }, "93": { iso2: "af", code: "93", name: "Afghanistan (‫افغانستان‬‎)" }, "94": { iso2: "lk", code: "94", name: "Sri Lanka (ශ්‍රී ලංකාව)" }, "95": { iso2: "mm", code: "95", name: "Myanmar (Burma) (မြန်မာ)" }, "98": { iso2: "ir", code: "98", name: "Iran (‫ایران‬‎)" }, "211": { iso2: "ss", code: "211", name: "South Sudan (‫جنوب السودان‬‎)" }, "212": {iso2: "eh", code: "212", name: "Western Sahara (‫الصحراء الغربية‬‎)"}, "213": { iso2: "dz", code: "213", name: "Algeria (‫الجزائر‬‎)" }, "216": { iso2: "tn", code: "216", name: "Tunisia (‫تونس‬‎)" }, "218": { iso2: "ly", code: "218", name: "Libya (‫ليبيا‬‎)" }, "220": { iso2: "gm", code: "220", name: "Gambia" }, "221": { iso2: "sn", code: "221", name: "Senegal (Sénégal)" }, "222": { iso2: "mr", code: "222", name: "Mauritania (‫موريتانيا‬‎)" }, "223": { iso2: "ml", code: "223", name: "Mali" }, "224": { iso2: "gn", code: "224", name: "Guinea (Guinée)" }, "225": { iso2: "ci", code: "225", name: "Côte d’Ivoire" }, "226": { iso2: "bf", code: "226", name: "Burkina Faso" }, "227": { iso2: "ne", code: "227", name: "Niger (Nijar)" }, "228": { iso2: "tg", code: "228", name: "Togo" }, "229": { iso2: "bj", code: "229", name: "Benin (Bénin)" }, "230": { iso2: "mu", code: "230", name: "Mauritius (Moris)" }, "231": { iso2: "lr", code: "231", name: "Liberia" }, "232": { iso2: "sl", code: "232", name: "Sierra Leone" }, "233": { iso2: "gh", code: "233", name: "Ghana (Gaana)" }, "234": { iso2: "ng", code: "234", name: "Nigeria" }, "235": { iso2: "td", code: "235", name: "Chad (Tchad)" }, "236": {iso2: "cf", code: "236", name: "Central African Republic (République centrafricaine)"}, "237": { iso2: "cm", code: "237", name: "Cameroon (Cameroun)" }, "238": { iso2: "cv", code: "238", name: "Cape Verde (Kabu Verdi)" }, "239": {iso2: "st", code: "239", name: "São Tomé and Príncipe (São Tomé e Príncipe)"}, "240": {iso2: "gq", code: "240", name: "Equatorial Guinea (Guinea Ecuatorial)"}, "241": { iso2: "ga", code: "241", name: "Gabon" }, "242": {iso2: "cg", code: "242", name: "Congo (Republic) (Congo-Brazzaville)"}, "243": {iso2: "cd", code: "243", name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)"}, "244": { iso2: "ao", code: "244", name: "Angola" }, "245": { iso2: "gw", code: "245", name: "Guinea-Bissau (Guiné Bissau)" }, "246": { iso2: "io", code: "246", name: "British Indian Ocean Territory" }, "248": { iso2: "sc", code: "248", name: "Seychelles" }, "249": { iso2: "sd", code: "249", name: "Sudan (‫السودان‬‎)" }, "250": { iso2: "rw", code: "250", name: "Rwanda" }, "251": { iso2: "et", code: "251", name: "Ethiopia" }, "252": { iso2: "so", code: "252", name: "Somalia (Soomaaliya)" }, "253": { iso2: "dj", code: "253", name: "Djibouti" }, "254": { iso2: "ke", code: "254", name: "Kenya" }, "255": { iso2: "tz", code: "255", name: "Tanzania" }, "256": { iso2: "ug", code: "256", name: "Uganda" }, "257": { iso2: "bi", code: "257", name: "Burundi (Uburundi)" }, "258": { iso2: "mz", code: "258", name: "Mozambique (Moçambique)" }, "260": { iso2: "zm", code: "260", name: "Zambia" }, "261": { iso2: "mg", code: "261", name: "Madagascar (Madagasikara)" }, "262": { iso2: "re", code: "262", name: "Réunion (La Réunion)" }, "263": { iso2: "zw", code: "263", name: "Zimbabwe" }, "264": { iso2: "na", code: "264", name: "Namibia (Namibië)" }, "265": { iso2: "mw", code: "265", name: "Malawi" }, "266": { iso2: "ls", code: "266", name: "Lesotho" }, "267": { iso2: "bw", code: "267", name: "Botswana" }, "268": { iso2: "sz", code: "268", name: "Swaziland" }, "269": { iso2: "km", code: "269", name: "Comoros (‫جزر القمر‬‎)" }, "290": { iso2: "sh", code: "290", name: "Saint Helena" }, "291": { iso2: "er", code: "291", name: "Eritrea" }, "297": { iso2: "aw", code: "297", name: "Aruba" }, "298": { iso2: "fo", code: "298", name: "Faroe Islands (Føroyar)" }, "299": { iso2: "gl", code: "299", name: "Greenland (Kalaallit Nunaat)" }, "350": { iso2: "gi", code: "350", name: "Gibraltar" }, "351": { iso2: "pt", code: "351", name: "Portugal" }, "352": { iso2: "lu", code: "352", name: "Luxembourg" }, "353": { iso2: "ie", code: "353", name: "Ireland" }, "354": { iso2: "is", code: "354", name: "Iceland (Ísland)" }, "355": { iso2: "al", code: "355", name: "Albania (Shqipëri)" }, "356": { iso2: "mt", code: "356", name: "Malta" }, "357": { iso2: "cy", code: "357", name: "Cyprus (Κύπρος)" }, "358": { iso2: "ax", code: "358", name: "Åland Islands" }, "359": { iso2: "bg", code: "359", name: "Bulgaria (България)" }, "370": { iso2: "lt", code: "370", name: "Lithuania (Lietuva)" }, "371": { iso2: "lv", code: "371", name: "Latvia (Latvija)" }, "372": { iso2: "ee", code: "372", name: "Estonia (Eesti)" }, "373": { iso2: "md", code: "373", name: "Moldova (Republica Moldova)" }, "374": { iso2: "am", code: "374", name: "Armenia (Հայաստան)" }, "375": { iso2: "by", code: "375", name: "Belarus (Беларусь)" }, "376": { iso2: "ad", code: "376", name: "Andorra" }, "377": { iso2: "mc", code: "377", name: "Monaco" }, "378": { iso2: "sm", code: "378", name: "San Marino" }, "380": { iso2: "ua", code: "380", name: "Ukraine (Україна)" }, "381": { iso2: "rs", code: "381", name: "Serbia (Србија)" }, "382": { iso2: "me", code: "382", name: "Montenegro (Crna Gora)" }, "383": { iso2: "xk", code: "383", name: "Kosovo" }, "385": { iso2: "hr", code: "385", name: "Croatia (Hrvatska)" }, "386": { iso2: "si", code: "386", name: "Slovenia (Slovenija)" }, "387": {iso2: "ba", code: "387", name: "Bosnia and Herzegovina (Босна и Херцеговина)"}, "389": { iso2: "mk", code: "389", name: "Macedonia (FYROM) (Македонија)" }, "420": { iso2: "cz", code: "420", name: "Czech Republic (Česká republika)" }, "421": { iso2: "sk", code: "421", name: "Slovakia (Slovensko)" }, "423": { iso2: "li", code: "423", name: "Liechtenstein" }, "500": { iso2: "fk", code: "500", name: "Falkland Islands (Islas Malvinas)" }, "501": { iso2: "bz", code: "501", name: "Belize" }, "502": { iso2: "gt", code: "502", name: "Guatemala" }, "503": { iso2: "sv", code: "503", name: "El Salvador" }, "504": { iso2: "hn", code: "504", name: "Honduras" }, "505": { iso2: "ni", code: "505", name: "Nicaragua" }, "506": { iso2: "cr", code: "506", name: "Costa Rica" }, "507": { iso2: "pa", code: "507", name: "Panama (Panamá)" }, "508": {iso2: "pm", code: "508", name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)"}, "509": { iso2: "ht", code: "509", name: "Haiti" }, "590": {iso2: "mf", code: "590", name: "Saint Martin (Saint-Martin (partie française))"}, "591": { iso2: "bo", code: "591", name: "Bolivia" }, "592": { iso2: "gy", code: "592", name: "Guyana" }, "593": { iso2: "ec", code: "593", name: "Ecuador" }, "594": { iso2: "gf", code: "594", name: "French Guiana (Guyane française)" }, "595": { iso2: "py", code: "595", name: "Paraguay" }, "596": { iso2: "mq", code: "596", name: "Martinique" }, "597": { iso2: "sr", code: "597", name: "Suriname" }, "598": { iso2: "uy", code: "598", name: "Uruguay" }, "599": { iso2: "cw", code: "599", name: "Curaçao" }, "670": { iso2: "tl", code: "670", name: "Timor-Leste" }, "672": { iso2: "nf", code: "672", name: "Norfolk Island" }, "673": { iso2: "bn", code: "673", name: "Brunei" }, "674": { iso2: "nr", code: "674", name: "Nauru" }, "675": { iso2: "pg", code: "675", name: "Papua New Guinea" }, "676": { iso2: "to", code: "676", name: "Tonga" }, "677": { iso2: "sb", code: "677", name: "Solomon Islands" }, "678": { iso2: "vu", code: "678", name: "Vanuatu" }, "679": { iso2: "fj", code: "679", name: "Fiji" }, "680": { iso2: "pw", code: "680", name: "Palau" }, "681": {iso2: "wf", code: "681", name: "Wallis and Futuna (Wallis-et-Futuna)"}, "682": { iso2: "ck", code: "682", name: "Cook Islands" }, "683": { iso2: "nu", code: "683", name: "Niue" }, "685": { iso2: "ws", code: "685", name: "Samoa" }, "686": { iso2: "ki", code: "686", name: "Kiribati" }, "687": {iso2: "nc", code: "687", name: "New Caledonia (Nouvelle-Calédonie)"}, "688": { iso2: "tv", code: "688", name: "Tuvalu" }, "689": {iso2: "pf", code: "689", name: "French Polynesia (Polynésie française)"}, "690": { iso2: "tk", code: "690", name: "Tokelau" }, "691": { iso2: "fm", code: "691", name: "Micronesia" }, "692": { iso2: "mh", code: "692", name: "Marshall Islands" }, "850": {iso2: "kp", code: "850", name: "North Korea (조선 민주주의 인민 공화국)"}, "852": { iso2: "hk", code: "852", name: "Hong Kong (香港)" }, "853": { iso2: "mo", code: "853", name: "Macau (澳門)" }, "855": { iso2: "kh", code: "855", name: "Cambodia (កម្ពុជា)" }, "856": { iso2: "la", code: "856", name: "Laos (ລາວ)" }, "880": { iso2: "bd", code: "880", name: "Bangladesh (বাংলাদেশ)" }, "886": { iso2: "tw", code: "886", name: "Taiwan (台灣)" }, "960": { iso2: "mv", code: "960", name: "Maldives" }, "961": { iso2: "lb", code: "961", name: "Lebanon (‫لبنان‬‎)" }, "962": { iso2: "jo", code: "962", name: "Jordan (‫الأردن‬‎)" }, "963": { iso2: "sy", code: "963", name: "Syria (‫سوريا‬‎)" }, "964": { iso2: "iq", code: "964", name: "Iraq (‫العراق‬‎)" }, "965": { iso2: "kw", code: "965", name: "Kuwait (‫الكويت‬‎)" }, "966": {iso2: "sa", code: "966", name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)"}, "967": { iso2: "ye", code: "967", name: "Yemen (‫اليمن‬‎)" }, "968": { iso2: "om", code: "968", name: "Oman (‫عُمان‬‎)" }, "970": { iso2: "ps", code: "970", name: "Palestine (‫فلسطين‬‎)" }, "971": {iso2: "ae", code: "971", name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)"}, "972": { iso2: "il", code: "972", name: "Israel (‫ישראל‬‎)" }, "973": { iso2: "bh", code: "973", name: "Bahrain (‫البحرين‬‎)" }, "974": { iso2: "qa", code: "974", name: "Qatar (‫قطر‬‎)" }, "975": { iso2: "bt", code: "975", name: "Bhutan (འབྲུག)" }, "976": { iso2: "mn", code: "976", name: "Mongolia (Монгол)" }, "977": { iso2: "np", code: "977", name: "Nepal (नेपाल)" }, "992": { iso2: "tj", code: "992", name: "Tajikistan" }, "993": { iso2: "tm", code: "993", name: "Turkmenistan" }, "994": { iso2: "az", code: "994", name: "Azerbaijan (Azərbaycan)" }, "995": { iso2: "ge", code: "995", name: "Georgia (საქართველო)" }, "996": { iso2: "kg", code: "996", name: "Kyrgyzstan (Кыргызстан)" }, "998": { iso2: "uz", code: "998", name: "Uzbekistan (Oʻzbekiston)" }, "1242": { iso2: "bs", code: "1242", name: "Bahamas" }, "1246": { iso2: "bb", code: "1246", name: "Barbados" }, "1264": { iso2: "ai", code: "1264", name: "Anguilla" }, "1268": { iso2: "ag", code: "1268", name: "Antigua and Barbuda" }, "1284": { iso2: "vg", code: "1284", name: "British Virgin Islands" }, "1340": { iso2: "vi", code: "1340", name: "U.S. Virgin Islands" }, "1345": { iso2: "ky", code: "1345", name: "Cayman Islands" }, "1441": { iso2: "bm", code: "1441", name: "Bermuda" }, "1473": { iso2: "gd", code: "1473", name: "Grenada" }, "1649": { iso2: "tc", code: "1649", name: "Turks and Caicos Islands" }, "1664": { iso2: "ms", code: "1664", name: "Montserrat" }, "1670": { iso2: "mp", code: "1670", name: "Northern Mariana Islands" }, "1671": { iso2: "gu", code: "1671", name: "Guam" }, "1684": { iso2: "as", code: "1684", name: "American Samoa" }, "1721": { iso2: "sx", code: "1721", name: "Sint Maarten" }, "1758": { iso2: "lc", code: "1758", name: "Saint Lucia" }, "1767": { iso2: "dm", code: "1767", name: "Dominica" }, "1784": {iso2: "vc", code: "1784", name: "Saint Vincent and the Grenadines"}, "1868": { iso2: "tt", code: "1868", name: "Trinidad and Tobago" }, "1869": { iso2: "kn", code: "1869", name: "Saint Kitts and Nevis" }, "1876": { iso2: "jm", code: "1876", name: "Jamaica" } };
// let sortedCountryCodes = ["93","355","213","1684","376","244","1264","1268","54","374","297","43","994","1242","973","880","1246","375","32","501","229","1441","975","591","387","267","55","246","1284","673","359","226","257","855","237","238","1345","236","235","56","86","61","57","269","243","242","682","506","385","53","599","357","420","225","45","253","1767","593","20","503","240","291","372","251","500","298","679","33","594","689","241","220","995","49","233","350","30","299","1473","1671","502","224","245","592","509","504","852","36","354","91","62","98","964","353","972","1876","81","962","254","686","383","965","996","856","371","961","266","231","218","423","370","352","853","389","261","265","60","960","223","356","692","596","222","230","52","691","373","377","976","382","1664","258","95","264","674","977","31","687","64","505","227","234","683","672","850","1670","968","92","680","970","507","675","595","51","63","48","351","974","40","7","250","262","290","1869","1758","590","508","1784","685","378","966","221","381","248","232","65","1721","421","386","677","252","27","82","211","34","94","249","597","47","268","46","41","963","239","886","992","255","66","670","228","690","676","1868","216","90","993","1649","688","1340","256","380","971","44","1","598","998","678","39","58","84","681","212","967","260","263","358"];

let Countries = {
  Countries: CountriesList,
  sortedCountryCodes: sortedCountryCodes,
};

export default Countries;
